import request from "@/utils/request";
// 关于我们提交接口
export function GetTijiao(data) {
  return request({
    url: "/other/from/active",
    method: "post",
    data
  });
}



// WEBPACK FOOTER //
// ./src/api/tijiao.js